module.exports = __webpack_public_path__ + "img/arts-bg.19e4490a.png";